import { usePWAContext, type DeviceType, type PWAContextValue } from "@/contexts/PWAContext";

export type { DeviceType };

export interface PWAInstallState extends PWAContextValue {}

/**
 * Hook to manage PWA installation state and actions.
 * Consumes the global PWAContext for shared state across all components.
 */
export function usePWAInstall(): PWAInstallState {
  return usePWAContext();
}
